export const STATUS_META = {
  new: { label: "New", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  contacted: { label: "Contacted", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  qualified: { label: "Qualified", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  quoted: { label: "Quoted", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  advance_paid: { label: "Advance Paid", cls: "bg-teal-50 text-teal-700 border-teal-200" },
  in_production: { label: "In Production", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  delivered: { label: "Delivered", cls: "bg-green-50 text-green-700 border-green-200" },
  won: { label: "Won", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  lost: { label: "Lost", cls: "bg-red-50 text-red-700 border-red-200" },
  test: { label: "Test", cls: "bg-slate-50 text-slate-400 border-slate-300" },
};

export const STATUS_OPTIONS = [
  "new", "contacted", "qualified", "quoted", "advance_paid",
  "in_production", "delivered", "won", "lost", "test",
];

export const FUNNEL_STAGES = ["new", "contacted", "qualified", "quoted", "advance_paid", "won"];

export const LOST_REASONS = ["no_response", "budget", "chose_other", "not_a_fit", "duplicate", "other"];
